// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iJeoKrVPtSfm2RxSsMMH{padding:.25rem .5rem;background-color:#2b2b2b;color:#fff;border-radius:.5rem;overflow:hidden;font-size:.75rem;font-weight:bold;min-width:2.5rem;text-align:center;align-items:center;margin-left:auto;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countdown": "iJeoKrVPtSfm2RxSsMMH"
};
export default ___CSS_LOADER_EXPORT___;
